import { RadioGroupStyles, RadioGroupTemplate } from "@fluentui/web-components";
import { RadioGroup } from "./radio-group.js";
import { DesignSystem } from "../design-system.js";
/**
 * The Fabric Radio Group component.
 *
 * @public
 */
export const definition = RadioGroup.compose({
    name: `${DesignSystem.prefix}-radio-group`,
    template: RadioGroupTemplate,
    styles: RadioGroupStyles,
    shadowOptions: {
        mode: DesignSystem.shadowRootMode
    }
});
//# sourceMappingURL=radio-group.definition.js.map